import React from 'react'

const Mobile_Testing = () => {
  return (
    <div>
        {/* collapseThirtyFour */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingThirtyFour">
                <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThirtyFour" aria-expanded="false" aria-controls="collapseThirtyFour">
                    Mobile Testing
                    <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div id="collapseThirtyFour" className="accordion-collapse collapse" aria-labelledby="headingThirtyFour" data-bs-parent="#accordionCourses">
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <ul>
                        <li>Introduction to Mobile Testing</li>
                        <li>Importance of Mobile Testing</li>
                        <li>Types of Mobile Application</li>
                        <li>Introduction of Mobile Application Testing</li>
                        <li>Difference between Mobile Testing & Mobile Application Testing</li>
                        <li>Mobile Testing Types</li>
                        <li>Tools Used for Mobile Testing</li>
                        <li>Appium Introduction</li>
                        <li>Appium Features</li>
                        <li>Appium Architecture</li>
                        <li>Mobile Application Testing</li>
                        <li>Appium Environmental Setup</li>
                        <li>Practicals Based on Appium</li>
                    </ul>

                </div>
            </div>
        </div>

    </div>
  )
}

export default Mobile_Testing